module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAWCAYAAAAmaHdCAAAAAXNSR0IArs4c6QAAAPhJREFUOE/tlL1KA0EUhb+zkMImTRQJaCBFtLSS1JZifCd9AhGLvIeFbyBkG3vXn2oN/qWwWSKueyQJEcUxbmW1c5sZOPfcuR9zR/HtwxZ53rdpIdUxkpiG7UgwPc6XMbbeJDJgVJgjxcnwHlgFXQunn+o/NkZL4C5QTEyegGWkg26neVjWZHDz2NF7ngCuTGbUKiY/X0/F5F+ZwAj0UnaKwTVg/fsUh7MLzAXSBrj+S4EvX0FAEVl725vNs8FVuiZH50ArIFtokmW118ZOuz2eJMbJ3SloP2xyOXxGNIJXFYkLH0vsgnoL2kl7oL7QSnmoM6XR2PjkA0a7+ZgN53BCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone.png
// module id = 5ng9
// module chunks = 1